import { Editor } from '@tiptap/react'
import { isEqual } from 'lodash'
import { useEffect } from 'react'
import { usePrevious } from '@opallabs/lambda'
import { TextEditorAsset } from '../types'

/**
 * Syncs the `assetStore` prop to editor storage.
 * Derives `assetsLoading` from whether the prop is undefined.
 */
export const useAssetStoreUpdate = (
  editor: Editor | null,
  assetStore?: TextEditorAsset[]
) => {
  const previousAssetStore = usePrevious(assetStore)

  useEffect(() => {
    if (!editor || editor.isDestroyed || editor.storage.asset === undefined) {
      return
    }

    const newAssetStore = assetStore ?? []

    // Only update and dispatch if the asset store has changed
    if (isEqual(previousAssetStore, assetStore)) {
      return
    }

    editor.storage.asset.assetsLoading = assetStore === undefined
    editor.storage.asset.assetStore = newAssetStore

    // Triggers editor update to notify useEditorState subscribers
    editor.view.dispatch(editor.state.tr)
  }, [editor, assetStore, previousAssetStore])
}
